function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import EmberDataPaginatedSerializer from '@square/dashboard-items-data/serializers/ember-data-paginated-serializer';
import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import { isNone, isEmpty } from '@ember/utils';
import { underscore } from '@ember/string';
export default class PurchaseOrder extends EmberDataPaginatedSerializer.extend(EmbeddedRecordsMixin) {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "primaryKey", 'token');
    _defineProperty(this, "collectionKey", 'purchase_orders');
    _defineProperty(this, "rootKey", 'purchase_order');
    _defineProperty(this, "modelName", 'squareup/inventory/v3/purchase-order');
    _defineProperty(this, "attrs", {
      vendor: {
        embedded: 'always'
      }
    });
  }
  serialize(snapshot, options) {
    const json = super.serialize(snapshot, options);
    if (isNone(json.token)) {
      delete json.token;
    }
    if (isEmpty(json.charge)) {
      delete json.charge;
    }
    return json;
  }
  serializeAttribute(snapshot, json, key, attributes) {
    super.serializeAttribute(snapshot, json, key, attributes);
    if (isNone(snapshot.attr(key))) {
      json[underscore(key)] = snapshot.attr(key);
    }
  }
  normalize(typeClass, hash, prop) {
    // EmberData can't handle pushing an embedded record with no id.
    // We remove the partial vendor here and add it back to the model after loading
    // as a new record.
    if (hash.vendor && !hash.vendor.token) {
      hash.draft_vendor = hash.vendor;
      delete hash.vendor;
    }
    return super.normalize(typeClass, hash, prop);
  }
}